module.exports = __webpack_public_path__ + "static/media/statistic-card-icon.0f73d1d5.svg";